// extracted by mini-css-extract-plugin
export default {"root":"BlockEmbededCode_root__6AZRf","media":"BlockEmbededCode_media__cTbOg","text":"BlockEmbededCode_text__EGKyH"};